import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from '../../../services/account.service';
@Component({
  selector: 'app-login-page',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})

export class RegistrationLoginPage implements OnInit {
  user: any = {
    username: '',
    password: ''
  }
  err: string;

  constructor(public accountService: AccountService, private router: Router, private translate: TranslateService) {}

  ngOnInit(): void {
    
  }

  ionViewDidEnter(){
    this.clearForm();
    this.clearErr();
  }

  clearForm(){
    this.user.username = '';
    this.user.password = '';
  }

  clearErr(){
    this.err = '';
  }

  login(){
    this.accountService.login(this.user).subscribe(res => {
      if(this.accountService.isAdminWithoutRoom()) {
        this.router.navigateByUrl('/registration/select-room');
      } else {
        this.router.navigateByUrl('/registration/home');
      }
    },error =>{
      this.err = this.translate.instant('LOGIN.bad_login')
      console.log(error);
    })
  }
}